import React from 'react';
import ChatInterface from '../../components/chat/ChatInterface';

const ChatPage: React.FC = () => {
  return (
    <div className="chat-page">
      <ChatInterface />
    </div>
  );
};

export default ChatPage;
